export const webviewAdUnits = {
  mobile: {
    webviewMasthead: {
      name: 'Onedio.com_App_Webview_Masthead',
      sizes: [
        [300, 250],
        [300, 150],
        [320, 100],
        [320, 150],
        [320, 50],
        [300, 100],
      ],
      isProject: true,
      divId: 'masthead',
    },
    webviewIcerikArasiTop: {
      name: 'Onedio.com_App_Webview_İçerikArası_Top',
      sizes: [[250, 250], [300, 250], [336, 280], 'fluid', [200, 200]],
      isProject: true,
    },
    webviewIcerikArasiBottom: {
      name: 'Onedio.com_App_Webview_İçerikArası_Bottom',
      sizes: [[200, 200], [320, 480], 'fluid', [250, 250], [336, 280], [300, 250]],
      isProject: true,
    },
  },
};
